import { useIntl } from 'react-intl';

const Label = ({ message }) => {
  const { formatMessage } = useIntl();
  const classNames = 'integration__label';

  return <label className={classNames}>{formatMessage({ id: message })}</label>;
};

export default Label;
